<div class="left-content abl" [class.grow]="left?.grow">
    <ng-content select="fbr-ab-left"></ng-content>
</div>
<div class="right-content abr" [class.grow]="right?.grow">
    <ng-content select="fbr-ab-right"></ng-content>
</div>
